$ ->
  $('.cw_richtext').summernote()
